module.exports = __webpack_public_path__ + "static/media/clientPhoto7.24239c80.png";